import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useI18n } from "@/i18n";
import { AuthShell, inputCls } from "@/pages/Login";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title={t("forgot.title")}>
      {sent ? (
        <p className="text-ink-soft" data-testid="forgot-sent">{t("forgot.sent")}</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <p className="text-ink-soft text-sm">{t("forgot.sub")}</p>
          <input type="email" required placeholder={t("auth.email")} value={email}
            onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="forgot-email" />
          {error && <p className="text-destructive text-sm">{error}</p>}
          <button type="submit" disabled={loading} data-testid="forgot-submit"
            className="w-full bg-gold text-void py-3 font-medium hover:bg-gold-hover transition-colors disabled:opacity-50">
            {loading ? t("common.loading") : t("forgot.btn")}
          </button>
        </form>
      )}
      <p className="text-center text-sm text-ink-muted mt-8">
        <Link to="/login" className="text-gold hover:text-gold-hover">{t("auth.toLogin")}</Link>
      </p>
    </AuthShell>
  );
}
